<template>
  <div v-if="length" class=" py-2 w-full mt-8 rounded-md relative">
    <v-pagination
      :total-visible="5"
      :length="length"
      v-model="page"
      circle
    ></v-pagination>
    <span class="absolute right-1 bottom-3   p-2 bg-stone-50    mr-2 border rounded-md"> {{ total }} <span class="text-slate-500">مورد</span></span>
  </div>
</template>

<script>
export default {
  props: ["value", "total", "currentView"],
  data() {
    return {
      page: this.value ? this.value : 1,
      length: 0,
    };
  },
  methods: {
    pageHandeller() {
      let num = Math.floor(this.total / this.currentView);
      if (this.total % this.currentView !== 0) {
        num++;
      }
      this.length = num;
    },
  },
  watch: {
    total() {
      this.pageHandeller();
    },
    page(v) {
      this.$emit("input", v);
    },
    value(v) {
      this.page = v;
    },
  },
  mounted() {
    this.pageHandeller();
  },
};
</script>

<style>

</style>